export default __webpack_public_path__ + "static/media/CD__0004_0001.1e32461f.png";